import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { KIDefinitionService } from '../../../../services/kidefinition.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-transcribe-settings',
    templateUrl: './transcribe.settings.html'
})
export class TranscribeSettings extends FormulaWorkflowDialogContent {
    Data = new TranscribeSettingsData();
    KIDefinitions: any[] = [];
    AvailableModels: string[] = [];
    MimeTypes = [
        { value: 'audio/mpeg', label: 'audio/mpeg (mp3)' },
        { value: 'audio/wav', label: 'audio/wav' },
        { value: 'audio/m4a', label: 'audio/m4a' },
        { value: 'audio/webm', label: 'audio/webm' },
        { value: 'audio/ogg', label: 'audio/ogg' },
        { value: 'audio/flac', label: 'audio/flac' }
    ];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'transcribeWFModule';
        reg.Caption = '@@KI: Audio transkribieren';
        reg.GroupID = 'aioperations';
        reg.Index = 102;
        reg.SettingsControl = TranscribeSettings;
        reg.SettingsTypeHelper = new TranscribeSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: KIDefinitionService) {
        super();
    }

    ngOnInit() {
        this.service.GetKIDefinitions('VoiceToText').subscribe(list => {
            this.KIDefinitions = list || [];
            if (this.Data.KIDefinition) {
                this.loadModels(this.Data.KIDefinition);
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, TranscribeSettingsData);
        }
    }

    onKIDefinitionChange() {
        this.Data.Model = '';
        this.AvailableModels = [];
        if (this.Data.KIDefinition) {
            this.loadModels(this.Data.KIDefinition);
        }
    }

    private loadModels(id: string) {
        this.service.LoadKIDefinition(id).subscribe(def => {
            const all = def?.Models || [];
            const filtered = all.filter(m => (m.Capabilities & 4) !== 0);
            this.AvailableModels = (filtered.length > 0 ? filtered : all).map(m => m.Name);
        });
    }

    getResult() {
        return this.Data;
    }
}

export class TranscribeSettingsData {
    KIDefinition: string;
    Model: string = '';
    AudioMimeType: string = 'audio/mpeg';
    Language: string = '';
}

export class TranscribeSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new TranscribeSettingsData();
    }
}
